export const API_URLS_REGEXP = /^\/?api\//;
export const CA_URLS_REGEXP = /capitalaccess\.ihsmarkit\.com/;
export const IPREO_URLS_REGEXP = /ipreo\.com/;
